import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.CustomPricePoint.List.IRequest;
type Response = Api.Core.CustomPricePoint.List.IResponse;
type Headers = Api.Core.CustomPricePoint.List.IHeaders;
const url = '/api/ProductManagement/CustomPricePoint';
export default async function customPricePointListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
